import { render, staticRenderFns } from "./TipoLibroNuevoEditar.vue?vue&type=template&id=4dd89b62&"
import script from "./TipoLibroNuevoEditar.vue?vue&type=script&lang=js&"
export * from "./TipoLibroNuevoEditar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports